import { useSelectedStudentIdContext } from "#/components/exam-results/context/studentsList/context";
import { MathJaxContent } from "#/components/mathjax";
import DOMPurify from "dompurify";
import ReactHtmlParser, {
  attributesToProps,
  domToReact,
  type DOMNode
} from "html-react-parser";
import { renderToString } from "react-dom/server";
import type { DqGlobalProps } from "../types";
import { getQuestionIndex, useGetQuestions } from "../utils";
import styles from "./dqBody.module.scss";
import { ReadOnlyOptions } from "./ReadOnlyOptions";

export const DescriptiveQuestionBody = (props: DqGlobalProps) => {
  const { id } = props;
  const { selectedStudentId } = useSelectedStudentIdContext();

  const { question, rowNo, numberOfChildren, questionTypeId, questionOrder1 } =
    useGetQuestions(selectedStudentId, id)[0];

  const addNumberToQuestion = (question: string) => {
    const html = DOMPurify.sanitize(question);

    const options = {
      replace(domNode) {
        const ELement = domNode.name ?? "div";
        const props = attributesToProps(domNode.attribs ?? {});

        return (
          <ELement {...props}>
            <span className={styles["dq-body__question__number"]}>
              {getQuestionIndex(
                questionTypeId,
                numberOfChildren,
                rowNo === 1 ? 0 : questionOrder1
              )}
            </span>
            {domToReact((domNode.children as DOMNode[]) ?? [])}
          </ELement>
        );
      }
    };

    const parsedHtml = ReactHtmlParser(html, options);

    return renderToString(parsedHtml);
  };

  const questionWithNumber = addNumberToQuestion(question);

  return (
    <section className={styles["dq-body"]}>
      <div className={styles["dq-body__question"]}>
        <MathJaxContent value={questionWithNumber ?? ""} />
      </div>
      <ReadOnlyOptions id={id} />
    </section>
  );
};
